import {
  getRelativeCropParams,
  getTileCropParams,
} from '../components/PhotoBank/tileUtils'
import { isPhoto } from '@mixtiles/web-backend-shared'
import { isRectInsideRect } from '../utils/rectUtils'
import { type Tile } from '../components/TilesProvider/TilesProvider.types'
import { type Rect } from '../utils/cropUtils.types'
import { type PhotoFaceData } from '../components/PhotoBank/PhotoBank.types'
import { getCropRelevantFaces } from 'utils/cropUtils'

type BadCropDetectionResult = {
  isBadCrop: boolean
  badCropReason?: string
  faceDetectionsBeforeCrop: Rect[]
  faceDetectionsAfterCrop: Rect[]
}

// Check for bad crop only for photo tiles
export function shouldDetectBadCrop(tile: Tile): boolean {
  return isPhoto(tile)
}

/**
 * Check if the tile has a bad crop for example:
 * - if there are more faces in the cropped image than in the original image
 * - if a face is out of the bounds of the crop rect
 */
export async function detectBadCrop(
  tile: Tile,
  allFaces: PhotoFaceData[]
): Promise<BadCropDetectionResult> {
  const faceDetectionsBeforeCrop = getCropRelevantFaces(allFaces)
  let isBadCrop = false
  let badCropReason
  const relativeCropParams = getRelativeCropParams(
    tile,
    getTileCropParams(tile)
  )

  const faceDetectionsAfterCrop = faceDetectionsBeforeCrop.filter((face) =>
    isRectInsideRect(relativeCropParams, face)
  )

  // Mark as bad crop if the original image had more faces than the cropped image
  if (faceDetectionsAfterCrop.length < faceDetectionsBeforeCrop.length) {
    isBadCrop = true
    badCropReason = 'Face Out of Bounds Cropped'
  }

  return {
    isBadCrop,
    badCropReason,
    faceDetectionsBeforeCrop,
    faceDetectionsAfterCrop,
  }
}
